export default {
  /**
   * @type {string} *
   * @description 系统标题
   */
  sysTitle: "后台管理系统",

  /**
   * @type {string} *
   * @description 版权公司
   */
  copyrightCompany: "测试版权",

};
